import * as React from "react";
import styled from "styled-components";
import Header from "../components/header/index";
import FormularioFormaParte from "../components/formaParte/formulario";
import DatosFormaParte from "../components/formaParte/datos";
import SeguroParaTodo from "../components/footer/seguroParaTodo";
import Footer from "../components/footer/index";

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: row;
  background-color: var(--white);
`;

export default function FormFormaParte() {
  return (
    <Container>
      {/* Header */}
      <Header></Header>
      {/* Formulario Forma Parte */}
      <FormularioFormaParte></FormularioFormaParte>
      {/* Datos Forma Parte */}
      <DatosFormaParte></DatosFormaParte>
      {/* Seguro Para Todo */}
      <SeguroParaTodo></SeguroParaTodo>
      {/* Footer */}
      <Footer></Footer>
    </Container>
  );
}
